module.exports = __webpack_public_path__ + "static/media/pl1.dfad62d6.png";